import { useState } from "react";

export const Navbar = () => {
  const [menu, setMenu] = useState(true);
  return (
    <div className="header-wrapper">
      <div className="logo-wrapper">
        <img src="assets/flower.png" alt="flower" />
        <p>Renia Flowers</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          fill={`${menu ? "black" : "white"}`}
          className="bi bi-list"
          viewBox="0 0 16 16"
          onClick={() => {
            setMenu(!menu);
          }}
        >
          <path
            fillRule="evenodd"
            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
          />
        </svg>
      </div>
      <nav className={`navbar ${menu ? "menu-slide" : ""}`}>
        <a href="/">Start</a>
        <a href="/about">O nas</a>
        <a href="/offer">Oferta</a>
        <a href="/shop" className="dropdown">
          <a
            className={`${menu ? `dropdown-toggle` : `dropdown-toggle-sm`}`}
            href="/shop"
            data-bs-toggle="dropdown"
          >
            Sklep
          </a>
          <ul className="dropdown-menu fade-up">
            <li>
              <a className="dropdown-item" href="/bouquets">
                Bukiety
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="/compositions">
                Kompozycje
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="/cemetery">
                Kompozycje nagrobne
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="/wreaths">
                Wieńce pogrzebowe
              </a>
            </li>
          </ul>
        </a>
        <a href="/contact">Kontakt</a>
        <a
          href="https://www.facebook.com/profile.php?id=100012840816877"
          target={"_blank"}
          rel="noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="white"
            className="bi bi-facebook"
            viewBox="0 0 16 16"
          >
            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
          </svg>
        </a>
        <a href="tel:+48883645559">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="white"
            className="bi bi-telephone"
            viewBox="0 0 16 16"
          >
            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
          </svg>
        </a>
      </nav>
    </div>
  );
};
